import { makeStyles } from '@material-ui/core/styles';

const rowWidth = { width: 'calc(100% - 50px)' };

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: (p) => (p.isMobileXS ? '100%' : 450),
    margin: '0 auto',
  },
  realmReset: {
    fontSize: 12,
    color: theme.palette.grey['600'],

    '& .MuiButton-label': {
      color: '#1d8df7',
    },
    '& .MuiIcon-root': {
      fontSize: 14,
    },
  },
  header: {
    margin: `${theme.spacing(1)}px 0`,
    fontWeight: 'bold',
  },
  grouping: {
    margin: `${theme.spacing(2)}px 0`,
  },
  noneYet: {
    fontStyle: 'italic',
    fontSize: 14,
    margin: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    ...rowWidth,
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 2,
  },
  rowWidth,
  templateButton: {
    backgroundColor: 'rgba(0, 0, 0, 0.02)',
    textTransform: 'none',
    height: 36,
    ...rowWidth,

    '& .MuiButton-label': {
      justifyContent: 'flex-start',
    },

    '& .MuiIcon-root': {
      color: '#1d8df7',
    },
  },
  templateButton2: {
    width: 40,
    minWidth: 'auto',
    marginLeft: theme.spacing(2),
  },
}));

export default useStyles;
